<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GDp5On/media/FC-9781398437234.jpg?1684514594268" alt="This image is the cover for the book Siblings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Siblings
      </h1>
      <p class="bookDescription body article font2">
        <p>A journey of a brother and sister who were abandoned by their parents and put in a care system. This seems to go well at first, until they are put forward for a foster placement, which goes downhill very quickly afterwards. <br/>Siblings is an engrossing family saga that you won't be able to put down.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Ellery
      </h2>
      
      <p class="authorDescription body article">Sharon Ellery was born and raised in London, and still resides there. This is her first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a4b40ae